var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"full-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-alert',{attrs:{"type":_vm.alert.type}},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")]),_c('a',{attrs:{"href":"/paypal/test"}},[_vm._v("Try again?")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }